import React, {Component} from 'react';
import {withRouter, Switch, Route, Redirect} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import Spinner from '../../components/Spinner';
import Header from '../../components/Header';
import AgentsList from '../../components/AgentsList';
import AgentInfo from '../../components/AgentInfo';
import KpiList from '../../components/KpiList';
import Chart from '../../components/Chart';
import AddAgentModal, {EditAgentModal} from '../../components/AddAgentModal';
import styles from './style.css';

function LeftSideListContainer({items, mapFunction, emptyListFallback, footer}) {
  return <div className={styles.container}>
    {items.length === 0
      ? <div className={styles.emptyList}>
        {emptyListFallback}
      </div>
      : <div className={styles.list}>
        {items.map(mapFunction)}
      </div>}
    {footer}
  </div>
}

const Desk = withRouter(inject('store')(observer(class Desk extends Component {
    state = {
      openedModal: false,
      modalData: null
    }

    onAddAgent = () => {
      this.setState({openedModal: true, modalData: {type: 'add'}})
    }

    onEditAgent = (agent) => () => {
      this.setState({openedModal: true, modalData: {type: 'edit', agent}})
    }

    onCloseModal = () => {
      this.setState({openedModal: false, modalData: null})
    }

    onAddAgentSuccess = () => {
      this.onCloseModal()
    }

    componentDidMount() {
      const {store} = this.props
      store.getCurrentUser()
      store.getAgentsListRequest()
      if (store.userCanSeeKPI()) {
        store.getKpiList()
      }
    }

    render() {
      const {store} = this.props
      const {modalData, openedModal} = this.state
      const modal = () => modalData.type === 'edit'
        ? <EditAgentModal onClose={this.onCloseModal} agent={modalData.agent} onSuccess={this.onAddAgentSuccess}/>
        : <AddAgentModal onClose={this.onCloseModal} onSuccess={this.onAddAgentSuccess}/>;
      return (
        <div className={styles.page}>
          <Header/>
          <div className={styles.content}>
            <Switch>
              <Route path={'/agents'} render={() => (
                <React.Fragment>
                  <AgentsList onAddAgent={this.onAddAgent} container={LeftSideListContainer}/>
                  <AgentInfo onEditAgent={this.onEditAgent}/>
                </React.Fragment>
              )}/>
              <Route path={'/kpi'} render={() => store.userCanSeeKPI() ? (
                <React.Fragment>
                  <KpiList container={LeftSideListContainer}/>
                  <Route path={'/kpi/:name'} component={KpiInfo}/>
                </React.Fragment>
              ) : <Redirect to={'/agents'}/>}/>
            </Switch>
          </div>
          {openedModal && modalData ? modal() : null}
        </div>
      )
    }
  })
))

const KpiInfo = inject('store')(observer(function KPIRoute(props) {
    const {location, store} = props
    const KPI = store.getKPI(location.pathname + location.search)
    if (KPI && KPI.data) {
      return <Chart type={'LINE'} data={KPI.data}/>
    } else if (KPI && KPI.data === null) {
      return <div>{'Not implemented'}</div>
    } else {
      return <Spinner/>
    }
}))

export default Desk;



// WEBPACK FOOTER //
// ./src/containers/Desk/index.js